import { Activity, useLayoutEffect, useRef } from "react"
import { CalendarTab } from "~/features/calendar/components/calendar-tab"
import { Catalog } from "~/features/catalog/components/catalog"
import { Chats } from "~/features/chats/components/chats"
import { Feed } from "~/features/feed/components/feed"
import { ProfileTab } from "~/features/profile/components/profile-tab"
import { PullToRefreshWrapper } from "~/components/pull-to-refresh-wrapper"
import type { TabId } from "./bottom-nav"

export const tabIds: TabId[] = ["feed", "catalog", "chat", "calendar", "profile"]

export const isTabId = (value: unknown): value is TabId => {
  return tabIds.some((tabId) => tabId === value)
}

interface Props {
  tab: TabId
}

export function TabContainer({ tab }: Props) {
  const scrollPositions = useRef<Partial<Record<TabId, number>>>({})
  const prevTab = useRef<TabId>(tab)

  useLayoutEffect(() => {
    if (prevTab.current === tab) return
    scrollPositions.current[prevTab.current] = window.scrollY
    prevTab.current = tab
    window.scrollTo(0, scrollPositions.current[tab] ?? 0)
  }, [tab])

  return (
    <>
      {tabIds.map((tabId) => (
        <Activity
          key={tabId}
          mode={tab === tabId ? "visible" : "hidden"}
        >
          <PullToRefreshWrapper useWindowScroll queryKeyPrefix={["home", tabId]}>
            <Tab tab={tabId} />
          </PullToRefreshWrapper>
        </Activity>
      ))}
    </>
  )
}

const Tab = ({ tab }: { tab: TabId }) => {
  switch (tab) {
    case "feed":
      return <Feed />
    case "catalog":
      return <Catalog />
    case "chat":
      return <Chats />
    case "calendar":
      return <CalendarTab />
    case "profile":
      return <ProfileTab />
  }

  return null
}
